import React from 'react';
import {
    NavLink,
    Link
} from 'react-router-dom'

class ProjectNav extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let {data} = this.props.projects;
        if(!Object.keys(data).length) return [];

        return (
            <div className="filter-grid grid_2">
                <NavLink to={`${process.env.PUBLIC_URL}/projects`} exact activeClassName="actv">All Projects</NavLink>
                <div className="filter-links">
                    <NavLink to={`${process.env.PUBLIC_URL}/projects/residential`} exact activeClassName="actv" >{data.types[3]}</NavLink>
                    <NavLink to={`${process.env.PUBLIC_URL}/projects/community`} exact activeClassName="actv" >{data.types[4]}</NavLink>
                    <NavLink to={`${process.env.PUBLIC_URL}/projects/commercial`} exact activeClassName="actv" >{data.types[2]}</NavLink>
                </div>
            </div>
        );
    }
}

export default ProjectNav;


// WEBPACK FOOTER //
// ./src/components/Projects/ProjectNav.js